<!-- Inter-Regional Component -->
<mat-drawer-container
  class="example-container relative bg-white-color"
  [hasBackdrop]="true"
  style="height: calc(100%) !important; overflow-y: scroll"
>
  <mat-drawer-content class="relative">
    <div class="container mx-auto flex flex-col lg:flex-row w-full">
      <!-- Main Form Area -->
      <div class="w-full lg:w-[65%] xl:w-4/5 2xl:w-5/6 h-full pt-4 lg:pt-8">
        <div
          class="flex items-start justify-between gap-2 md:mb-7 sm:mb-5 mb-3"
        >
          <div class="flex items-center gap-2">
            <button mat-icon-button class="max-h-[24px]" routerLink="/">
              <mat-icon class="mat-18 text-orange-color">arrow_back</mat-icon>
            </button>
            <h4 class="text-base sm:text-lg md:text-xl font-semibold">
              {{ country === "Ghana" ? "Inter-Regional" : "Inter-State" }}
            </h4>
          </div>

          <div
            *ngIf="this.docIdFire && this.form.get('pickupLocation').value"
            (click)="resetOrderFlow()"
            class="flex items-center text-orange-color gap-1 font-semibold text-base cursor-pointer"
          >
            <mat-icon
              matTooltip="Proceeding with this action will reset your current order data, and this action cannot be undone."
              class="mat-18 !text-xl"
              >info_outline</mat-icon
            >
            <div class="hover:underline">Reset Form</div>
          </div>
        </div>
        <form [formGroup]="form">
          <!-- Step 1: Location Details -->
          <div *ngIf="stepIndex === 0">
            <h2 class="text-[26px] font-bold mb-[30px] text-[#0B1640]">
              Nationwide Delivery. Fast. Reliable.
            </h2>
            <h4 class="font-semibold text-[20px] mb-4">
              Who's Sending The Package?
            </h4>

            <div
              class="text-[13px] font-medium sm:text-sm md:text-base !custom-dark-gray mb-3"
            >
              {{ tipText }}
            </div>

            <div class="flex flex-col sm:flex-row gap-4 mb-6">
              <div
                class="option-card relative"
                [ngClass]="{ selected: senderType === 'individual' }"
                (click)="selectSender('individual')"
              >
                <img
                  src="assets/images/icons/individual.svg"
                  class="w-[40px]"
                  alt="Individual"
                />
                <div>
                  <div class="font-bold">Individual</div>
                  <div class="text-xs text-gray-500">
                    Perfect for personal or one-time deliveries.
                  </div>
                </div>
              </div>
              <div
                class="option-card"
                [ngClass]="{ selected: senderType === 'business' }"
                (click)="selectSender('business')"
              >
                <img
                  src="assets/images/icons/business.svg"
                  class="w-[40px]"
                  alt="Business"
                />
                <div>
                  <div class="font-bold">Business</div>
                  <div class="text-xs text-gray-500">
                    Ideal for sellers, merchants, and bulk deliveries.
                  </div>
                </div>
              </div>
            </div>
            <div class="sm:mb-6">
              <h4 class="font-semibold text-lg mb-2">Pickup Detail</h4>
              <div class="flex flex-col sm:flex-row gap-4 mb-[20px]">
                <div
                  class="option-card"
                  [ngClass]="{ selected: pickupType === 'door' }"
                  (click)="selectPickup('door')"
                >
                  <div
                    class="absolute top-0 right-2 bg-green-color text-white-color text-xs px-2 py-1 rounded-b-lg font-medium z-10"
                  >
                    Recommended
                  </div>
                  <img
                    src="assets/images/icons/door-pickup.svg"
                    class="w-[40px]"
                    alt="Door Pickup"
                  />
                  <div>
                    <div class="font-bold">Door Pickup</div>
                    <div class="text-xs text-gray-500">
                      Rider collects from you
                    </div>
                  </div>
                </div>
                <div
                  class="option-card"
                  [ngClass]="{ selected: pickupType === 'self' }"
                  (click)="selectPickup('self')"
                >
                  <img
                    src="assets/images/icons/self-dropoff.svg"
                    class="w-[40px]"
                    alt="Self Dropoff"
                  />
                  <div>
                    <div class="font-bold">Self Dropoff</div>
                    <div class="text-xs text-gray-500">
                      You bring to our site
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="font-medium mb-[10px]">Pickup Location</label>
                <mat-form-field
                  appearance="fill"
                  class="w-full"
                  (click)="onPickupLocation()"
                >
                  <input
                    matInput
                    placeholder="Tap to enter exact pickup location"
                    formControlName="pickupLocation"
                    readonly
                  />
                  <mat-icon matSuffix class="text-orange-color"
                    >location_on</mat-icon
                  >
                </mat-form-field>
              </div>
            </div>
            <!-- For Individual -->
            <div class="mb-6" *ngIf="senderType === 'individual'">
              <h4 class="font-semibold text-lg mb-2">Dropoff Detail</h4>
              <div class="flex flex-col sm:flex-row gap-4 mb-[20px]">
                <div
                  class="option-card"
                  [ngClass]="{ selected: dropoffType === 'door' }"
                  (click)="selectDropoff('door')"
                >
                  <div
                    class="absolute top-0 right-2 bg-green-color text-white-color text-xs px-2 py-1 rounded-b-lg font-medium z-10"
                  >
                    Recommended
                  </div>
                  <img
                    src="assets/images/icons/door-pickup.svg"
                    class="w-[40px]"
                    alt="Door Dropoff"
                  />
                  <div>
                    <div class="font-bold">Door Dropoff</div>
                    <div class="text-xs text-gray-500">We bring it to them</div>
                  </div>
                </div>
                <div
                  class="option-card"
                  [ngClass]="{ selected: dropoffType === 'self' }"
                  (click)="selectDropoff('self')"
                >
                  <img
                    src="assets/images/icons/self-dropoff.svg"
                    class="w-[40px]"
                    alt="Self Pickup"
                  />
                  <div>
                    <div class="font-bold">Self Pickup</div>
                    <div class="text-xs text-gray-500">
                      You bring to our site
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="font-medium mb-[10px]">Dropoff Location</label>
                <mat-form-field appearance="fill" class="w-full">
                  <input
                    matInput
                    placeholder="Tap to enter exact dropoff location"
                    readonly
                    formControlName="dropoffLocation"
                    (click)="
                      form.get('pickupLocation').value &&
                        this.onDropOffLocation(
                          this.dropoffLocations['controls'],
                          0
                        )
                    "
                  />
                  <mat-icon matSuffix class="text-orange-color"
                    >location_on</mat-icon
                  >
                </mat-form-field>
              </div>
            </div>
            <!-- For Business -->
            <div class="mb-6" *ngIf="senderType === 'business'">
              <h4 class="font-semibold text-lg mb-2 text-blue-theme-color">
                Number Of Dropoff Location
              </h4>
              <div
                class="flex items-center justify-between bg-transparent rounded-[12px] border border-[#D8DFE7] px-6 py-4 max-w-[340px]"
              >
                <button
                  type="button"
                  (click)="decrementDropoff()"
                  class="border border-[#CBD5E1] rounded-md w-10 h-10 flex items-center justify-center text-2xl text-[#0B1640]"
                >
                  -
                </button>
                <span class="mx-8 text-3xl font-bold text-[#0B1640]">
                  {{ dropoffCount }}
                </span>
                <button
                  type="button"
                  (click)="incrementDropoff()"
                  class="border border-[#F54720] rounded-md w-10 h-10 flex items-center justify-center text-2xl text-[#F54720]"
                >
                  +
                </button>
              </div>
            </div>
            <div class="pb-[25px]">
              <button
                mat-flat-button
                color="primary"
                class="bg-blue-theme-color gap-2 flex justify-center items-center !px-12 !h-14 text-white-color rounded-md"
                [disabled]="!canProceedToNextStep()"
                [class.opacity-50]="!canProceedToNextStep()"
                [class.cursor-not-allowed]="!canProceedToNextStep()"
                [matTooltip]="getValidationErrorMessage()"
                [matTooltipDisabled]="
                  canProceedToNextStep() || !getValidationErrorMessage()
                "
                matTooltipPosition="above"
                (click)="nextStep()"
              >
                Next
              </button>
            </div>
          </div>

          <!-- Step 2: Delivery Plan, Package Size, Handling, Trust Check -->
          <div *ngIf="stepIndex === 1">
            <!-- For Individual -->
            <ng-container *ngIf="senderType === 'individual'">
              <h4 class="font-semibold text-lg mb-4">Select Delivery Plan</h4>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div
                  class="option-card"
                  [ngClass]="{ selected: deliveryPlan === 'express' }"
                  (click)="selectPlan('express')"
                >
                  <img
                    src="assets/images/icons/express.svg"
                    class="w-[40px]"
                    alt="Express"
                  />
                  <div>
                    <div class="font-bold">Express</div>
                    <div class="text-xs text-gray-500">
                      Delivers in 48 hours. Ideal for urgent needs.
                    </div>
                  </div>
                </div>
                <div
                  class="option-card"
                  [ngClass]="{ selected: deliveryPlan === 'regular' }"
                  (click)="selectPlan('regular')"
                >
                  <img
                    src="assets/images/icons/regular.svg"
                    class="w-[40px]"
                    alt="Regular"
                  />
                  <div>
                    <div class="font-bold">Regular</div>
                    <div class="text-xs text-gray-500">
                      Within 72 hours. Good for standard deliveries.
                    </div>
                  </div>
                </div>
                <div
                  class="option-card"
                  [ngClass]="{ selected: deliveryPlan === 'saver' }"
                  (click)="selectPlan('saver')"
                >
                  <img
                    src="assets/images/icons/saver.svg"
                    class="w-[40px]"
                    alt="Saver"
                  />
                  <div>
                    <div class="font-bold">Saver</div>
                    <div class="text-xs text-gray-500">
                      Within 72+ business hours. Best for cost-saving needs.
                    </div>
                  </div>
                </div>
              </div>
              <!-- Package Size Section (reuse from bulk order) -->
              <h4 class="font-semibold text-lg mb-4">Select Package Size</h4>
              <div class="row mb-[30px]">
                <div
                  class="grid xs:grid-cols-2 sm:grid-cols-4 xl:grid-cols-5 gap-[14px]"
                >
                  <ng-container
                    *ngFor="let item of this.packsizes; let i = index"
                  >
                    <div
                      matRipple
                      (click)="onSelectPackage(i)"
                      [ngClass]="
                        item.isSelected
                          ? 'border-orange-color bg-orange-color/5'
                          : 'border-gray-color '
                      "
                      class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative cursor-pointer border-2 items-center bg-white rounded-lg flex flex-col justify-between"
                    >
                      <div class="flex-1 flex flex-col mr-auto">
                        <span
                          class="md:text-lg sm:text-base text-base text-blue-theme-color font-semibold"
                          >{{ item.name }}</span
                        >
                        <span
                          class="text-[13px] text-[#7C8390] font-Inter-Medium font-medium"
                          >{{ item.info | titlecase }}</span
                        >
                      </div>
                      <img
                        draggable="false"
                        [src]="item.icon"
                        class="w-[50px] rounded-lg object-contain aspect-square ml-auto"
                        alt=""
                      />

                      <img
                        *ngIf="item.isSelected"
                        class="absolute w-5 aspect-square top-2 right-2"
                        src="assets/images/icons/checkMark.svg"
                        alt=""
                      />
                      <div class="flex justify-between"></div>
                    </div>
                  </ng-container>
                </div>
                <p
                  *ngIf="this.form.get('orderPackageSize')?.value?.desc"
                  class="text-base text-input-color font-Inter-Medium pt-2 font-medium"
                >
                  {{ this.form.get("orderPackageSize").value.desc }}
                </p>
              </div>
              <!-- Handling Section (reuse from standard order) -->
              <h4 class="font-semibold text-lg mb-4">What Are We handling?</h4>
              <div class="row mb-[30px]">
                <div
                  class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                >
                  <ng-container
                    *ngFor="let item of this.handlingMethods; let i = index"
                  >
                    <div
                      matRipple
                      (click)="selectHandlingMethods(i)"
                      [ngClass]="
                        item.isSelected
                          ? 'border-orange-color bg-orange-color/5'
                          : 'border-gray-color '
                      "
                      class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex md:flex-row sm:justify-start sm:flex-row flex-col cursor-pointer border items-center rounded-lg sm:gap-3 gap-1"
                    >
                      <img
                        draggable="false"
                        [src]="item.icon"
                        class="w-[40px] aspect-square"
                        alt=""
                      />
                      <span
                        class="text-base text-blue-theme-color sm:text-left text-center font-semibold"
                        >{{ item.title | titlecase }}</span
                      >
                      <img
                        *ngIf="item.isSelected"
                        class="absolute w-5 aspect-square top-2 right-2"
                        src="assets/images/icons/checkMark.svg"
                        alt=""
                      />
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Package Item Section (reuse from standard order) -->
              <h4
                *ngIf="this.handlingData?.length > 0"
                class="font-semibold text-lg mb-4"
              >
                Select Package Item
              </h4>
              <div class="row mb-2">
                <div
                  class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 md:gap-5 sm:gap-3 gap-2"
                >
                  <ng-container
                    *ngFor="let item of this.handlingData; let i = index"
                  >
                    <div
                      (click)="onSelectPackagedItem(i)"
                      [ngClass]="
                        item.isSelected
                          ? 'border-orange-color bg-orange-color/5'
                          : 'border-light-gray bg-white-color'
                      "
                      matRipple
                      class="rounded-lg border relative cursor-pointer flex sm:flex-row flex-col items-center gap-2 px-4 md:py-4 sm:py-3 py-3"
                    >
                      <img
                        [src]="item.images"
                        onerror="this.onerror = null; this.src='assets/images/icons/other.png'"
                        draggable="false"
                        class="w-[30px] aspect-square"
                        alt=""
                      />
                      <span
                        class="text-blue-theme-color break-words sm:text-left sm:leading-5 leading-4 text-center text-sm font-medium sm:pr-0 pr-0"
                        >{{ item.title | titlecase }}</span
                      >
                      <img
                        *ngIf="item.isSelected"
                        class="absolute w-5 aspect-square top-2 right-2"
                        src="assets/images/icons/checkMark.svg"
                        alt=""
                      />
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Other Package Item Input for Individual -->
              <div
                @showHide
                *ngIf="form.get('selectedHandlingItem')?.value?.id === 0"
                class="row md:w-[400px] mt-4 w-full sm:w-full mb-2"
              >
                <mat-form-field appearance="outline" class="pr-0 w-full">
                  <input
                    formControlName="attachmentInfo"
                    matInput
                    placeholder="Enter Package Description..."
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="
                      !this.form.get('attachment').dirty &&
                      !this.attachmentUploadedUrl
                    "
                    (click)="itemAttachment.click()"
                    matTooltip="Attach Image"
                    matRipple
                    class="w-[40px] aspect-square flex items-center justify-center rounded-full"
                  >
                    <mat-icon class="mat-18 text-blue-theme-color"
                      >attach_file</mat-icon
                    >
                  </button>
                  <mat-progress-spinner
                    matSuffix
                    *ngIf="this.form.get('attachment').dirty"
                    class="imageUpload pr-6"
                    [diameter]="24"
                    [mode]="'indeterminate'"
                  ></mat-progress-spinner>
                  <input
                    type="file"
                    class="invisible w-0 h-0"
                    (change)="onAttachmentSelect($event)"
                    formControlName="attachment"
                    #itemAttachment
                    accept="image/png, image/gif, image/jpeg"
                  />
                </mat-form-field>
              </div>

              <!-- Image Preview for Individual -->
              <div
                @showHide
                *ngIf="
                  form.get('selectedHandlingItem')?.value?.id === 0 &&
                  this.attachmentUploadedUrl &&
                  isAttachmentUploaded
                "
                class="row md:w-[400px] mt-2 w-full sm:w-full mb-4"
              >
                <div class="w-52 aspect-video relative">
                  <img
                    [src]="this.attachmentUploadedUrl"
                    class="w-full h-full object-cover rounded-lg"
                    alt=""
                  />
                  <button
                    (click)="onRemoveAttachment()"
                    mat-icon-button
                    matRipple
                    class="absolute w-[30px] aspect-square flex items-center justify-center rounded-full top-1 right-1 bg-white/80"
                  >
                    <mat-icon class="mat-18 text-orange-color">close</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

            <!-- For Business -->
            <ng-container *ngIf="senderType === 'business'">
              <div>
                <h2 class="text-xl font-bold mb-4">Location Detail</h2>
                <div
                  class="bg-white border border-[#D8DFE7] rounded-xl p-6 mb-6 flex flex-col gap-2 relative"
                >
                  <div
                    class="absolute top-4 right-4 cursor-pointer text-[#5C637E]"
                    (click)="this.stepIndex = 0"
                  >
                    <mat-icon>edit</mat-icon>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div
                      class="font-semibold text-blue-theme-color text-[16px]"
                    >
                      Pickup Location
                    </div>
                    <div class="flex flex-col gap-1">
                      <div class="font-medium text-blue-theme-color text-sm">
                        {{ pickupName }}
                      </div>
                      <div class="text-gray-600 text-sm">
                        {{
                          pickupAddress ||
                            form.get("pickupLocation")?.value ||
                            "No pickup address selected"
                        }}
                      </div>
                      <div class="flex items-center gap-[6px]">
                        <img
                          [src]="
                            pickupType === 'door'
                              ? 'assets/images/icons/door-pickup.svg'
                              : 'assets/images/icons/self-dropoff.svg'
                          "
                          class="w-[22px] h-[22px]"
                          [alt]="
                            pickupType === 'door'
                              ? 'Door Pickup'
                              : 'Self Dropoff'
                          "
                        />

                        <p
                          class="font-medium text-blue-theme-color text-[14px]"
                        >
                          {{
                            pickupType === "door"
                              ? "Door Pickup"
                              : "Self Dropoff"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <ng-container
                  *ngIf="
                    this.isBusinessPartner &&
                    this.form.get('pickupLocation').value
                  "
                >
                  <div class="mb-6 flex justify-between items-center">
                    <div class="inline-flex items-start gap-2">
                      <img
                        src="assets/images/ui/CSV-icon.png"
                        class="w-6 aspect-square object-contain cursor-pointer"
                        alt=""
                      />
                      <div>
                        <p
                          class="text-[16px] text-blue-theme-color font-semibold"
                        >
                          Upload Drop-off Locations
                        </p>
                        <p class="text-sm">
                          (Easily import multiple drop-off locations for bulk
                          deliveries via a csv file)
                        </p>
                      </div>
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        color="primary"
                        class="bg-blue-theme-color gap-2 flex justify-center items-center !px-[30px] !h-14 text-white-color rounded-md"
                        (click)="openImportDropoffDialog()"
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </ng-container>
                <!-- Add Drop-Off Location Section -->
                <h2
                  class="text-[20px] flex items-center gap-2 mb-[15px] font-bold text-blue-theme-color"
                >
                  Add Drop-Off Location
                  <button
                    mat-icon-button
                    matRipple
                    (click)="
                      addDropRow(this.dropoffLocations['controls'].length);
                      $event.stopPropagation()
                    "
                    class="border bg-[#387DF4] border-none w-[30px] flex items-center justify-center aspect-square rounded-md"
                  >
                    <mat-icon class="mat-12 text-white-color">add</mat-icon>
                  </button>
                </h2>
                <!-- Dropoff tab group -->
                <mat-tab-group
                  #tabGroup
                  mat-align-tabs="start"
                  [(selectedIndex)]="selectedIndex"
                  (selectedTabChange)="updateDropOff()"
                  class="dropLocationTabsGroup min-h-[200px]"
                  mat-align-tabs="start"
                >
                  <ng-container formArrayName="dropoffLocations">
                    <ng-container
                      *ngFor="
                        let dropoff of dropoffLocations.controls;
                        let dropIndex = index
                      "
                    >
                      <mat-tab>
                        <ng-template mat-tab-label class="w-[48px]">
                          <span
                            [ngClass]="{
                              'tab-valid': dropoff.valid,
                              'invalid-and-touched':
                                dropoff.touched && dropoff.invalid
                            }"
                            >{{ dropIndex + 1 }}</span
                          >
                          <mat-icon
                            *ngIf="dropoff.valid"
                            class="!mat-12 !rounded-full !p-1.5 !text-base text-white-color bg-green-color"
                            >done</mat-icon
                          >
                          <mat-icon
                            *ngIf="canRemoveDropoff(dropIndex)"
                            (click)="
                              removeTab(dropIndex); $event.stopPropagation()
                            "
                            class="absolute right-[-3px] top-[-3px] z-10 text-orange-color"
                            >cancel</mat-icon
                          >
                        </ng-template>
                        <div
                          class="flex flex-col sm:gap-[0px] gap-[0px] md:gap-[10px]"
                          [formGroup]="dropoff"
                        >
                          <!-- Dropoff Type Selection for Business -->
                          <div class="sm:mb-6 mt-2 sm:mt-0">
                            <h4 class="font-semibold text-lg mb-2">
                              Dropoff Detail
                            </h4>
                            <div
                              class="flex flex-col sm:flex-row gap-4 mb-[20px]"
                            >
                              <div
                                class="option-card"
                                [ngClass]="{
                                  selected:
                                    dropoff.get('isDoorToDoorDropoff')
                                      ?.value === true
                                }"
                                (click)="
                                  dropoff
                                    .get('isDoorToDoorDropoff')
                                    ?.setValue(true);
                                  updateBusinessDropoffModel();
                                  syncModelToFirebase()
                                "
                              >
                                <div
                                  class="absolute top-0 right-2 bg-green-color text-white-color text-xs px-2 py-1 rounded-b-lg font-medium z-10"
                                >
                                  Recommended
                                </div>
                                <img
                                  src="assets/images/icons/door-pickup.svg"
                                  class="w-[40px]"
                                  alt="Door Dropoff"
                                />
                                <div>
                                  <div class="font-bold">Door Dropoff</div>
                                  <div class="text-xs text-gray-500">
                                    We bring it to them
                                  </div>
                                </div>
                              </div>
                              <div
                                class="option-card"
                                [ngClass]="{
                                  selected:
                                    dropoff.get('isDoorToDoorDropoff')
                                      ?.value === false
                                }"
                                (click)="
                                  dropoff
                                    .get('isDoorToDoorDropoff')
                                    ?.setValue(false);
                                  updateBusinessDropoffModel();
                                  syncModelToFirebase()
                                "
                              >
                                <img
                                  src="assets/images/icons/self-dropoff.svg"
                                  class="w-[40px]"
                                  alt="Self Pickup"
                                />
                                <div>
                                  <div class="font-bold">Self Pickup</div>
                                  <div class="text-xs text-gray-500">
                                    They collect from our site
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Only dropoff-specific controls here -->
                          <div
                            class="flex flex-col sm:flex-row sm:gap-[20px] sm:mb-0 mb-4"
                          >
                            <!-- Update the Name field to include validation like bulk order -->
                            <div class="flex flex-col w-full max-w-[350px]">
                              <label class="label font-medium">Name</label>
                              <mat-form-field
                                class="flex-1 form-field"
                                appearance="fill"
                              >
                                <input
                                  formControlName="contactPerson"
                                  matInput
                                  class="mt-1"
                                  placeholder="Enter Receiver Name"
                                  (input)="onDropoffContactChange(dropIndex)"
                                />
                                <mat-error>{{
                                  dropoff
                                    .get("contactPerson")
                                    .hasError("pattern")
                                    ? "Invalid Value"
                                    : dropoff
                                        .get("contactPerson")
                                        .hasError("required")
                                    ? "Receiver Name Required"
                                    : ""
                                }}</mat-error>
                              </mat-form-field>
                            </div>

                            <!-- Update the Contact Number section to match bulk order validation -->
                            <div
                              class="md:h-[75px] sm:h-[75px] h-[75px] w-full"
                            >
                              <div
                                class="country-code-field flex-1 form-field"
                                appearance="outline"
                              >
                                <label class="label mb-[1px] font-medium"
                                  >Contact Number</label
                                >
                                <div
                                  class="relative flex items-center border p-2.5 overflow-hidden border-[#D5D5D5] !rounded-md"
                                >
                                  <div
                                    class="absolute flex h-full max-w-16 overflow-hidden w-16"
                                  >
                                    <mat-select
                                      appearance="outline"
                                      tabindex="-1"
                                      [disabled]="true"
                                      (selectionChange)="changeCountry()"
                                      class="!flex !items-center"
                                      (click)="$event.stopPropagation()"
                                      [(value)]="selectedCountryCode"
                                    >
                                      <mat-option
                                        *ngFor="let country of countries"
                                        [value]="country.code.toString()"
                                      >
                                        <div class="flex flex-row gap-1">
                                          <img
                                            class="w-6 aspect-square object-contain"
                                            [src]="country.logo"
                                            alt=""
                                          />
                                          <p>{{ country.code }}</p>
                                        </div>
                                      </mat-option>
                                    </mat-select>
                                  </div>
                                  <input
                                    (click)="$event.stopPropagation()"
                                    [maxlength]="
                                      selectedCountryCode == '+233'
                                        ? checkZeroNumber(
                                            dropoff.get('personNumber')?.value,
                                            dropIndex
                                          )
                                          ? '10'
                                          : '9'
                                        : checkZeroNumber(
                                            dropoff.get('personNumber')?.value,
                                            dropIndex
                                          )
                                        ? '11'
                                        : '10'
                                    "
                                    formControlName="personNumber"
                                    matInput
                                    style="padding-left: 75px !important"
                                    class="flex-1"
                                    placeholder="Enter Mobile Number"
                                    type="text"
                                    appNoSpaces
                                    (input)="
                                      onPhoneNumberInput($event, dropIndex);
                                      onDropoffContactChange(dropIndex)
                                    "
                                  />
                                </div>
                                <div class="flex flex-col">
                                  <span
                                    class="text-red text-xs font-medium mt-1"
                                    *ngIf="
                                      dropoff
                                        .get('personNumber')
                                        .hasError('pattern')
                                    "
                                    >Invalid number</span
                                  >
                                  <span
                                    class="text-red text-xs font-medium mt-1"
                                    *ngIf="
                                      dropoff.get('personNumber').touched &&
                                      dropoff
                                        .get('personNumber')
                                        .hasError('required')
                                    "
                                    >Mobile number is required</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row mt-3 sm:mt-0 mb-4">
                            <label class="form-label">Dropoff Location</label>
                            <mat-form-field
                              appearance="fill"
                              class="w-full"
                              (click)="
                                onDropOffLocation(
                                  dropoffLocations.controls,
                                  dropIndex
                                )
                              "
                            >
                              <input
                                matInput
                                placeholder="Tap to enter exact dropoff location"
                                formControlName="dropoffPointAddress"
                                readonly
                              />
                              <mat-icon matSuffix class="text-orange-color"
                                >location_on</mat-icon
                              >
                            </mat-form-field>
                            <div
                              class="text-red text-xs"
                              *ngIf="
                                dropoff
                                  .get('dropoffPointAddress')
                                  ?.hasError('destinationNotFound') &&
                                (dropoff.get('dropoffPointAddress')?.touched ||
                                  dropoff.get('dropoffPointAddress')?.dirty)
                              "
                            >
                              Destination not supported. Please select a
                              location within supported destinations.
                            </div>
                          </div>

                          <div
                            class="text-[13px] font-medium sm:text-sm md:text-base !custom-dark-gray mb-3"
                          >
                            {{ tipText }}
                          </div>

                          <!-- Delivery Plan Section -->
                          <h4 class="font-semibold text-lg mb-4">
                            Select Delivery Plan
                          </h4>
                          <div
                            class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"
                          >
                            <div
                              class="option-card"
                              [ngClass]="{
                                selected:
                                  (dropoff.get('deliveryPlan')?.value ||
                                    deliveryPlan) === 'express'
                              }"
                              (click)="selectPlan('express', dropIndex)"
                            >
                              <img
                                src="assets/images/icons/express.svg"
                                class="w-[40px]"
                                alt="Express"
                              />
                              <div>
                                <div class="font-bold">Express</div>
                                <div class="text-xs text-gray-500">
                                  Delivers in 48 hours. Ideal for urgent needs.
                                </div>
                              </div>
                            </div>
                            <div
                              class="option-card"
                              [ngClass]="{
                                selected:
                                  (dropoff.get('deliveryPlan')?.value ||
                                    deliveryPlan) === 'regular'
                              }"
                              (click)="selectPlan('regular', dropIndex)"
                            >
                              <img
                                src="assets/images/icons/regular.svg"
                                class="w-[40px]"
                                alt="Regular"
                              />
                              <div>
                                <div class="font-bold">Regular</div>
                                <div class="text-xs text-gray-500">
                                  Within 72 hours. Good for standard deliveries.
                                </div>
                              </div>
                            </div>
                            <div
                              class="option-card"
                              [ngClass]="{
                                selected:
                                  (dropoff.get('deliveryPlan')?.value ||
                                    deliveryPlan) === 'saver'
                              }"
                              (click)="selectPlan('saver', dropIndex)"
                            >
                              <img
                                src="assets/images/icons/saver.svg"
                                class="w-[40px]"
                                alt="Saver"
                              />
                              <div>
                                <div class="font-bold">Saver</div>
                                <div class="text-xs text-gray-500">
                                  Within 72+ business hours. Best for
                                  cost-saving needs.
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Package Size Section -->
                          <h4 class="font-semibold text-lg mb-4">
                            Select Package Size
                          </h4>
                          <div class="row mb-[30px]">
                            <div
                              class="grid 2xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                            >
                              <ng-container
                                *ngFor="
                                  let item of dropoff.get('packageSizes').value;
                                  let i = index
                                "
                              >
                                <div
                                  matRipple
                                  (click)="
                                    onSelectPackageForBusiness(i, dropIndex)
                                  "
                                  [ngClass]="[
                                    item?.isSelected
                                      ? 'border-orange-color bg-orange-color/5'
                                      : 'border-gray-color   bg-slaty-color',
                                    i ===
                                      dropoff.get('packageSizes').value.length -
                                        1 &&
                                    dropoff.get('packageSizes').value.length %
                                      2 !==
                                      0
                                      ? 'col-span-2 md:col-span-1'
                                      : ''
                                  ]"
                                  class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative cursor-pointer border-2 items-center bg-white rounded-lg flex flex-col justify-between"
                                >
                                  <div class="flex-1 flex flex-col mr-auto">
                                    <span
                                      class="md:text-lg sm:text-base text-base text-blue-theme-color font-semibold"
                                      >{{ item.name }}</span
                                    >
                                    <span
                                      class="text-[13px] text-[#7C8390] font-Inter-Medium font-medium"
                                      >{{ item.info | titlecase }}</span
                                    >
                                  </div>
                                  <img
                                    draggable="false"
                                    [src]="item.icon"
                                    class="w-[50px] rounded-lg object-contain aspect-square ml-auto"
                                    alt=""
                                  />
                                  <img
                                    *ngIf="item.isSelected"
                                    class="absolute w-5 aspect-square top-2 right-2"
                                    src="assets/images/icons/checkMark.svg"
                                    alt=""
                                  />
                                </div>
                              </ng-container>
                            </div>
                            <p
                              *ngIf="dropoff.get('packageSize')?.value?.desc"
                              class="text-base text-input-color font-Inter-Medium pt-2 font-medium"
                            >
                              {{ dropoff.get("packageSize").value.desc }}
                            </p>
                          </div>

                          <!-- Handling Section -->
                          <h4 class="font-semibold text-lg mb-2">
                            What Are We handling?
                          </h4>
                          <div class="row mb-[30px]">
                            <div
                              class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                            >
                              <ng-container
                                *ngFor="
                                  let item of dropoff.get('handlingItems')
                                    .value;
                                  let i = index
                                "
                              >
                                <div
                                  matRipple
                                  (click)="
                                    selectHandlingMethodsForBusiness(
                                      i,
                                      dropIndex
                                    )
                                  "
                                  [ngClass]="[
                                    item?.isSelected
                                      ? 'border-orange-color bg-orange-color/5'
                                      : 'border-gray-color   bg-slaty-color',
                                    i ===
                                      dropoff.get('handlingItems').value
                                        .length -
                                        1 &&
                                    dropoff.get('handlingItems').value.length %
                                      2 !==
                                      0
                                      ? 'col-span-2 md:col-span-1'
                                      : ''
                                  ]"
                                  class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex md:flex-row sm:justify-start sm:flex-row flex-col cursor-pointer border items-center rounded-lg sm:gap-3 gap-1"
                                >
                                  <img
                                    draggable="false"
                                    [src]="item.icon"
                                    class="w-[40px] aspect-square"
                                    alt=""
                                  />
                                  <span
                                    class="text-base text-blue-theme-color sm:text-left text-center font-semibold"
                                    >{{ item.title | titlecase }}</span
                                  >
                                  <img
                                    *ngIf="item.isSelected"
                                    class="absolute w-5 aspect-square top-2 right-2"
                                    src="assets/images/icons/checkMark.svg"
                                    alt=""
                                  />
                                </div>
                              </ng-container>
                            </div>
                          </div>

                          <!-- Package Item Section -->
                          <h4
                            *ngIf="
                              dropoff.get('handlingSubItems').value.length > 0
                            "
                            class="font-semibold text-lg mb-4"
                          >
                            Select Package Items
                          </h4>
                          <div class="row mb-2">
                            <div
                              class="grid 2xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                            >
                              <ng-container
                                *ngFor="
                                  let item of dropoff.get('handlingSubItems')
                                    .value;
                                  let i = index
                                "
                              >
                                <div
                                  (click)="
                                    onSelectPackagedItemForBusiness(
                                      i,
                                      dropIndex
                                    )
                                  "
                                  [ngClass]="[
                                    item?.isSelected
                                      ? 'border-orange-color bg-orange-color/5'
                                      : 'border-gray-color   bg-slaty-color',
                                    i ===
                                      dropoff.get('handlingSubItems').value
                                        .length -
                                        1 &&
                                    dropoff.get('handlingSubItems').value
                                      .length %
                                      2 !==
                                      0
                                      ? 'col-span-2 md:col-span-1'
                                      : ''
                                  ]"
                                  matRipple
                                  class="rounded-lg border relative cursor-pointer flex sm:flex-row flex-col items-center gap-2 px-4 md:py-4 sm:py-3 py-3"
                                >
                                  <img
                                    [src]="item.images"
                                    onerror="this.onerror = null; this.src='assets/images/icons/other.png'"
                                    draggable="false"
                                    class="w-[33px] aspect-square"
                                    alt=""
                                  />
                                  <span
                                    class="text-blue-theme-color break-words sm:text-left sm:leading-5 leading-4 text-center text-smfont-medium sm:pr-0 pr-0"
                                    >{{ item.title | titlecase }}</span
                                  >
                                  <img
                                    *ngIf="item.isSelected"
                                    class="absolute w-5 aspect-square top-2 right-2"
                                    src="assets/images/icons/checkMark.svg"
                                    alt=""
                                  />
                                </div>
                              </ng-container>
                            </div>
                          </div>

                          <!-- Other Package Item Input for Business -->
                          <div
                            @showHide
                            *ngIf="
                              dropoff.get('selectedSubItem')?.value?.id === 0
                            "
                            class="row md:w-[400px] mt-4 w-full sm:w-full mb-4"
                          >
                            <mat-form-field
                              appearance="outline"
                              class="pr-0 w-full"
                            >
                              <input
                                formControlName="attachmentInfo"
                                matInput
                                placeholder="Enter package description..."
                              />
                              <button
                                mat-icon-button
                                matSuffix
                                *ngIf="
                                  !dropoff.get('attachment').dirty &&
                                  !dropoff.get('attachmentUrl')?.value
                                "
                                (click)="businessAttachment.click()"
                                matTooltip="Attach Image"
                                matRipple
                                class="w-[40px] aspect-square flex items-center justify-center rounded-full"
                              >
                                <mat-icon class="mat-18 text-blue-theme-color"
                                  >attach_file</mat-icon
                                >
                              </button>
                              <mat-progress-spinner
                                matSuffix
                                *ngIf="dropoff.get('attachment').dirty"
                                class="imageUpload pr-6"
                                [diameter]="24"
                                [mode]="'indeterminate'"
                              ></mat-progress-spinner>
                              <input
                                type="file"
                                class="invisible w-0 h-0"
                                (change)="
                                  onBusinessAttachmentSelect($event, dropIndex)
                                "
                                formControlName="attachment"
                                #businessAttachment
                                accept="image/png, image/gif, image/jpeg"
                              />
                            </mat-form-field>
                          </div>

                          <!-- Image Preview for Business -->
                          <div
                            @showHide
                            *ngIf="
                              dropoff.get('selectedSubItem')?.value?.id === 0 &&
                              dropoff.get('attachmentUrl')?.value &&
                              dropoff.get('isAttachmentUploaded')?.value
                            "
                            class="row md:w-[400px] mt-2 w-full sm:w-full mb-4"
                          >
                            <div class="w-52 aspect-video relative">
                              <img
                                [src]="dropoff.get('attachmentUrl')?.value"
                                class="w-full h-full object-cover rounded-lg"
                                alt=""
                              />
                              <button
                                (click)="onRemoveBusinessAttachment(dropIndex)"
                                mat-icon-button
                                matRipple
                                class="absolute w-[30px] aspect-square flex items-center justify-center rounded-full top-1 right-1 bg-white/80"
                              >
                                <mat-icon class="mat-18 text-orange-color"
                                  >close</mat-icon
                                >
                              </button>
                            </div>
                          </div>

                          <div
                            class="grid grid-cols-1 pt-4 gap-4"
                            [ngClass]="{
                              'md:grid-cols-2':
                                isItemCostApplied && senderType === 'individual'
                            }"
                          >
                            <div
                              *ngIf="
                                this.orderDoc?.isPhlenutrustCheckEnabled == 1
                              "
                              class="option-card"
                            >
                              <img
                                src="assets/images/bulkOrder/trustCheck.svg"
                                class="w-[40px]"
                              />
                              <div
                                class="flex justify-between items-start w-full"
                              >
                                <div class="text-[#0B1640]">
                                  <div class="font-bold text-[18px]">
                                    Phlenu TrustCheck
                                  </div>
                                  <div class="text-[14px]">
                                    Our delivery personnel will verify your item
                                    at pickup to ensure accuracy and prevent
                                    fraud before delivery.
                                  </div>
                                </div>
                                <mat-slide-toggle
                                  [checked]="
                                    dropoffLocations.controls[
                                      selectedIndex
                                    ]?.get('isPhlenuTrustCheckApplied')?.value
                                  "
                                  (change)="
                                    senderType === 'individual'
                                      ? toggleTrustCheck()
                                      : updateBusinessTrustCheck()
                                  "
                                >
                                </mat-slide-toggle>
                              </div>
                            </div>
                            <div
                              class="option-card !max-w-[455px]"
                              *ngIf="
                                isItemCostApplied && senderType === 'individual'
                              "
                            >
                              <img
                                src="assets/images/bulkOrder/trustCheck.svg"
                                class="w-[40px]"
                              />
                              <div class="flex justify-between items-start">
                                <div class="text-[#0B1640]">
                                  <div class="font-bold text-[18px]">
                                    Security Cover
                                  </div>
                                  <div class="text-[14px]">
                                    Protect your item with
                                    <ng-container *ngIf="coverFeePercent > 0">
                                      {{ coverFeePercent }}%
                                    </ng-container>
                                    cover for loss/damage
                                  </div>
                                </div>
                                <mat-slide-toggle
                                  [checked]="securityCover"
                                  (change)="toggleSecurityCover()"
                                >
                                </mat-slide-toggle>
                              </div>
                            </div>
                          </div>

                          <!-- Security Cover Section - Only show when cash collection is enabled -->
                          <!-- <div *ngIf="isCashCollection" class="mb-6">
                            <h4 class="font-semibold text-lg mb-4">
                              Security Cover
                            </h4>
                            <div class="option-card !max-w-[455px]">
                              <img
                                src="assets/images/bulkOrder/trustCheck.svg"
                                class="w-[40px]"
                              />
                              <div class="flex justify-between items-start">
                                <div class="text-[#0B1640]">
                                  <div class="font-bold text-[18px]">
                                    Security Cover
                                  </div>
                                  <div class="text-[14px]">
                                    Protect your item with {{this.coverFeePercent}}% cover for
                                    loss/damage.
                                  </div>
                                </div>
                                <mat-slide-toggle
                                  [checked]="
                                    dropoff.get('isSecurityCoverApplied')?.value
                                  "
                                  (change)="
                                    updateBusinessSecurityCoverForDropoff(
                                      dropIndex,
                                      $event.checked
                                    )
                                  "
                                >
                                </mat-slide-toggle>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </mat-tab>
                    </ng-container>
                  </ng-container>
                </mat-tab-group>

                <!-- Update the navigation buttons to match bulk order design -->
                <div
                  class="flex pb-[8px] mb-[10px] border-b-2 border-gray-color justify-between items-center"
                >
                  <div *ngIf="selectedIndex == 0"></div>
                  <button
                    mat-fab
                    (click)="goToPreviousLocation()"
                    *ngIf="selectedIndex != 0"
                    matRipple
                    class="text-orange-color flex items-center py-1 px-3 gap-2 md:text-lg sm:text-base text-base"
                  >
                    <mat-icon class="mat-18">west</mat-icon> Previous Location
                  </button>

                  <button
                    *ngIf="
                      selectedIndex != dropoffLocations.controls.length - 1
                    "
                    mat-fab
                    (click)="goToNextLocation()"
                    matRipple
                    class="text-orange-color flex items-center py-1 px-3 gap-2 md:text-lg sm:text-base text-base"
                  >
                    Next Location <mat-icon class="mat-18">east</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

            <div *ngIf="senderType === 'individual'">
              <!-- Cash Collection for Sold Item -->
              <div class="option-card w-full my-6">
                <div class="flex w-full justify-between items-center">
                  <div class="text-[#0B1640]">
                    <div class="font-bold text-[18px]">
                      Cash Collection for Sold Item
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <mat-slide-toggle
                      [checked]="cashCollection"
                      (change)="toggleCashCollection()"
                    >
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>

              <div class="option-card mb-6" *ngIf="cashCollection" @fadeInOut>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 w-full gap-4 items-center mb-2"
                >
                  <!-- Item Cost Input -->
                  <div *ngIf="cashCollection" class="w-full">
                    <label
                      class="block text-[#0B1640] text-[14px] font-medium mb-2"
                    >
                      Enter Item Cost
                    </label>
                    <div class="relative">
                      <mat-form-field appearance="outline" class="w-full">
                        <input
                          matInput
                          type="number"
                          formControlName="itemCost"
                          (input)="onItemCostInput($event)"
                          placeholder="Enter item cost"
                          [class.border-red-300]="
                            form.get('itemCost').value &&
                            form.get('itemCost').value <= 0
                          "
                        />
                        <button
                          matSuffix
                          mat-icon-button
                          (click)="updateItemCost()"
                          [disabled]="
                            !form.get('itemCost').value || isItemCostUpdating
                          "
                          class="bg-blue-theme-color hover:bg-blue-theme-color/90 disabled:bg-gray-400 text-white font-medium py-2 px-4 rounded-md transition-all duration-200 flex items-center justify-center gap-1 text-sm text-white-color"
                        >
                          <span>{{
                            isItemCostUpdating
                              ? "Updating..."
                              : isItemCostApplied
                              ? "Applied"
                              : "Apply"
                          }}</span>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Subtract Delivery Fee Option -->
                  <div
                    class="flex flex-col justify-end"
                    *ngIf="isItemCostApplied"
                  >
                    <label
                      class="block text-[#0B1640] text-[14px] font-medium mb-2"
                    >
                      Delivery Fee Deduction
                    </label>
                    <mat-slide-toggle
                      [checked]="subtractDeliveryFee"
                      (change)="
                        subtractDeliveryFee = $event.checked; updateItemCost()
                      "
                      [disabled]="!cashCollection"
                      color="primary"
                    >
                      Subtract delivery fee
                    </mat-slide-toggle>
                  </div>

                  <!-- Subtract Pickup Fee Option -->
                  <div
                    class="flex flex-col justify-end"
                    *ngIf="isItemCostApplied"
                  >
                    <label
                      class="block text-[#0B1640] text-[14px] font-medium mb-2"
                    >
                      Pickup Fee Deduction
                    </label>
                    <mat-slide-toggle
                      [checked]="subtractPickupFee"
                      (change)="
                        subtractPickupFee = $event.checked; updateItemCost()
                      "
                      [disabled]="!cashCollection"
                      color="primary"
                    >
                      Subtract pickup fee
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 pt-4 gap-4 mb-6"
              [ngClass]="{
                'md:grid-cols-2':
                  isItemCostApplied && senderType === 'individual'
              }"
              *ngIf="senderType === 'individual'"
            >
              <div
                *ngIf="
                  senderType === 'individual' &&
                  this.orderDoc?.isPhlenutrustCheckEnabled == 1
                "
                class="option-card"
              >
                <img
                  src="assets/images/bulkOrder/trustCheck.svg"
                  class="w-[40px]"
                />
                <div class="flex justify-between items-start w-full">
                  <div class="text-[#0B1640]">
                    <div class="font-bold text-[18px]">Phlenu TrustCheck</div>
                    <div class="text-[14px]">
                      Our delivery personnel will verify your item at pickup to
                      ensure accuracy and prevent fraud before delivery.
                    </div>
                  </div>
                  <mat-slide-toggle
                    [checked]="
                      senderType === 'individual'
                        ? trustCheck
                        : dropoffLocations.controls[selectedIndex]?.get(
                            'isPhlenuTrustCheckApplied'
                          )?.value
                    "
                    (change)="
                      senderType === 'individual'
                        ? toggleTrustCheck()
                        : updateBusinessTrustCheck()
                    "
                  >
                  </mat-slide-toggle>
                </div>
              </div>
              <div
                class="option-card !max-w-[455px]"
                *ngIf="isItemCostApplied && senderType === 'individual'"
              >
                <img
                  src="assets/images/bulkOrder/trustCheck.svg"
                  class="w-[40px]"
                />
                <div class="flex justify-between items-start">
                  <div class="text-[#0B1640]">
                    <div class="font-bold text-[18px]">Security Cover</div>
                    <div class="text-[14px]">
                      Protect your item with
                      <ng-container *ngIf="coverFeePercent > 0">
                        {{ coverFeePercent }}%
                      </ng-container>
                      cover for loss/damage
                    </div>
                  </div>
                  <mat-slide-toggle
                    [checked]="securityCover"
                    (change)="toggleSecurityCover()"
                  >
                  </mat-slide-toggle>
                </div>
              </div>
            </div>

            <div class="flex items-center justify-between gap-[10px] pb-[25px]">
              <button
                mat-flat-button
                color="primary"
                class="bg-blue-theme-color gap-2 flex justify-center items-center !px-12 !h-14 text-white-color rounded-md"
                (click)="prevStep()"
              >
                Back
              </button>
              <button
                mat-flat-button
                color="primary"
                class="bg-blue-theme-color gap-2 flex justify-center items-center !px-12 !h-14 text-white-color rounded-md"
                [disabled]="!canProceedToNextStep()"
                [class.opacity-50]="!canProceedToNextStep()"
                [class.cursor-not-allowed]="!canProceedToNextStep()"
                [matTooltip]="getValidationErrorMessage()"
                [matTooltipDisabled]="
                  canProceedToNextStep() || !getValidationErrorMessage()
                "
                matTooltipPosition="above"
                (click)="nextStep()"
              >
                Review Order
              </button>
            </div>
          </div>

          <!-- Step 3: Review/Payment -->
          <div *ngIf="stepIndex === 2">
            <!-- Location Detail Section (read-only, as in screenshot) -->
            <div *ngIf="senderType === 'individual'">
              <h2 class="text-xl font-bold mb-4">Location Detail</h2>
              <div
                class="bg-white border border-[#D8DFE7] rounded-xl p-6 mb-6 flex flex-col gap-2 relative"
              >
                <div
                  class="absolute top-4 right-4 cursor-pointer text-[#5C637E]"
                  (click)="this.stepIndex = 0"
                >
                  <mat-icon>edit</mat-icon>
                </div>
                <div class="location-wrapper mt-3">
                  <div class="pickup-point sideDashedBorder">
                    <div class="flex items-center gap-2">
                      <span class="drop-index text-xs !text-[#F54720]"
                        >Pickup location</span
                      >
                      <div
                        *ngIf="getPickUpLegend() && !isLoadingPaymentData"
                        style="
                          width: 8px;
                          height: 8px;
                          border-radius: 4px;
                          background-color: #f54720;
                          margin-left: 8px;
                        "
                      ></div>
                      <div
                        *ngIf="!getPickUpLegend() && !isLoadingPaymentData"
                        style="
                          width: 8px;
                          height: 8px;
                          border-radius: 4px;
                          background-color: #008000;
                          margin-left: 8px;
                        "
                      ></div>
                    </div>

                    <div class="font-semibold">{{ pickupName }}</div>
                    <div class="text-gray-600 text-sm">
                      {{
                        pickupAddress ||
                          form.get("pickupLocation")?.value ||
                          "No pickup address selected"
                      }}
                    </div>
                  </div>
                  <div class="drop-point">
                    <div class="flex items-center gap-2">
                      <span class="drop-index !text-[#F54720] text-xs"
                        >Dropoff location</span
                      >
                      <div
                        *ngIf="getDropOffLegend(0) && !isLoadingPaymentData"
                        style="
                          width: 8px;
                          height: 8px;
                          border-radius: 4px;
                          background-color: #f54720;
                          margin-left: 8px;
                        "
                      ></div>
                      <div
                        *ngIf="!getDropOffLegend(0) && !isLoadingPaymentData"
                        style="
                          width: 8px;
                          height: 8px;
                          border-radius: 4px;
                          background-color: #008000;
                          margin-left: 8px;
                        "
                      ></div>
                    </div>

                    <div class="font-semibold">
                      {{ dropoffModel[0]?.contactPerson }}
                    </div>
                    <div class="text-gray-600 text-sm">
                      {{
                        dropoffModel[0]?.location?.address ||
                          form.get("dropoffLocation")?.value ||
                          "No dropoff address selected"
                      }}
                    </div>
                    <!-- <div
                      *ngIf="this.orderDoc?.dropDetails?.length > 0"
                      class="text-[12px] text-blue-theme-color font-semibold"
                    >
                      {{ this.orderDoc?.dropDetails[0]?.dropOffDistanceToDs }}
                      km from Pickup
                    </div> -->
                  </div>
                </div>
              </div>

              <!-- Individual Dropoff Details -->
              <div class="bg-white border border-[#D8DFE7] rounded-xl p-6 mb-6">
                <h3 class="text-[16px] font-semibold text-[#0B1640] mb-4">
                  Dropoff Details
                </h3>
                <div class="grid grid-cols-2 gap-[22px]">
                  <div class="flex flex-col gap-[8px]">
                    <p class="text-[#7C8390] font-medium text-[12px]">
                      Delivery Plan
                    </p>
                    <div class="flex items-center gap-[6px]">
                      <img
                        [src]="
                          deliveryPlan === 'express'
                            ? 'assets/images/icons/express.svg'
                            : deliveryPlan === 'regular'
                            ? 'assets/images/icons/regular.svg'
                            : 'assets/images/icons/saver.svg'
                        "
                        class="w-[22px] h-[22px]"
                        alt="Delivery Plan"
                      />
                      <p class="font-medium text-blue-theme-color text-[14px]">
                        {{
                          deliveryPlan === "express"
                            ? "Express"
                            : deliveryPlan === "regular"
                            ? "Regular"
                            : "Saver"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col gap-[8px]">
                    <p class="text-[#7C8390] font-medium text-[12px]">
                      Dropoff Type
                    </p>
                    <div class="flex items-center gap-[6px]">
                      <img
                        [src]="
                          dropoffType === 'door'
                            ? 'assets/images/icons/door-pickup.svg'
                            : 'assets/images/icons/self-dropoff.svg'
                        "
                        class="w-[22px] h-[22px]"
                        [alt]="
                          dropoffType === 'door'
                            ? 'Door Dropoff'
                            : 'Self Pickup'
                        "
                      />
                      <p class="font-medium text-blue-theme-color text-[14px]">
                        {{
                          dropoffType === "door"
                            ? "Door Dropoff"
                            : "Self Pickup"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col gap-[8px]">
                    <p
                      class="text-[#7C8390] font-medium text-[12px] flex align-center gap-1"
                    >
                      <mat-icon>local_shipping</mat-icon>
                      Delivery Fee
                    </p>
                    <p class="font-medium text-blue-theme-color text-[14px]">
                      {{
                        hasDoorToDoorDropoffAtIndex(0) &&
                        getIndividualtotalcharges(0) > 0
                          ? getIndividualtotalcharges(0)
                          : "No Fee"
                      }}
                    </p>
                  </div>
                  <div class="flex flex-col gap-[8px]">
                    <p class="text-[#7C8390] font-medium text-[12px]">
                      Security Cover
                    </p>
                    <p class="font-medium text-blue-theme-color text-[14px]">
                      {{ securityCover ? "Enabled" : "Disabled" }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Distribution Site Legend -->
              <div class="mt-6 w-full">
                <div class="bg-white border border-[#D8DFE7] rounded-xl p-4">
                  <div class="flex items-center gap-2 mb-2">
                    <div class="w-2 h-2 rounded-full bg-green-color"></div>
                    <span class="text-sm font-medium text-black"
                      >Near Distribution Site</span
                    >
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="w-2 h-2 rounded-full bg-orange-color"></div>
                    <span class="text-sm font-medium text-black"
                      >Far from Distribution Site</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="senderType === 'business'" class="mb-[30px]">
              <div
                class="bg-white border border-[#D8DFE7] rounded-xl p-6 mb-6 flex flex-col gap-2 relative max-w-[550px]"
              >
                <div
                  class="absolute top-4 right-4 cursor-pointer text-[#5C637E]"
                  (click)="this.stepIndex = 0"
                >
                  <mat-icon>edit</mat-icon>
                </div>
                <div class="flex flex-col gap-2">
                  <div class="flex items-center gap-2">
                    <div
                      class="font-semibold text-blue-theme-color text-[16px]"
                    >
                      Pickup Location
                    </div>
                    <div
                      *ngIf="getPickUpLegend() && !isLoadingPaymentData"
                      style="
                        width: 8px;
                        height: 8px;
                        border-radius: 4px;
                        background-color: #f54720;
                        margin-left: 8px;
                      "
                    ></div>
                    <div
                      *ngIf="!getPickUpLegend() && !isLoadingPaymentData"
                      style="
                        width: 8px;
                        height: 8px;
                        border-radius: 4px;
                        background-color: #008000;
                        margin-left: 8px;
                      "
                    ></div>
                  </div>

                  <div class="flex flex-col gap-1">
                    <div class="font-medium text-blue-theme-color text-sm">
                      {{ pickupName }}
                    </div>
                    <div class="text-gray-600 text-sm">
                      {{
                        pickupAddress ||
                          form.get("pickupLocation")?.value ||
                          "No pickup address selected"
                      }}
                    </div>
                    <div class="flex items-center gap-[6px]">
                      <img
                        [src]="
                          pickupType === 'door'
                            ? 'assets/images/icons/door-pickup.svg'
                            : 'assets/images/icons/self-dropoff.svg'
                        "
                        class="w-[22px] h-[22px]"
                        [alt]="
                          pickupType === 'door' ? 'Door Pickup' : 'Self Dropoff'
                        "
                      />

                      <p class="font-medium text-blue-theme-color text-[14px]">
                        {{
                          pickupType === "door" ? "Door Pickup" : "Self Dropoff"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cash Collection Toggle -->
              <div class="option-card mb-6 max-w-[550px] w-full">
                <div
                  class="flex items-center gap-[10px] justify-between w-full"
                >
                  <div class="text-[16px] font-semibold text-[#0B1640]">
                    Cash Collection for Sold Item
                  </div>
                  <mat-slide-toggle
                    [checked]="isCashCollection || isCashCollectionApplied"
                    (change)="toggleBusinessCashCollection($event)"
                  ></mat-slide-toggle>
                </div>
              </div>

              <!-- Dropoff Locations -->
              <div class="space-y-4">
                <div
                  *ngFor="
                    let dropoff of dropoffLocations.controls;
                    let i = index
                  "
                  class="bg-white border border-[#D8DFE7] rounded-xl p-6 max-w-[550px]"
                >
                  <div class="flex justify-between items-start">
                    <div>
                      <div class="flex items-center gap-2">
                        <h3 class="text-[16px] font-semibold text-[#0B1640]">
                          Dropoff Location {{ i + 1 }}
                        </h3>
                        <div
                          *ngIf="getDropOffLegend(i) && !isLoadingPaymentData"
                          style="
                            width: 8px;
                            height: 8px;
                            border-radius: 4px;
                            background-color: #f54720;
                            margin-left: 8px;
                          "
                        ></div>
                        <div
                          *ngIf="!getDropOffLegend(i) && !isLoadingPaymentData"
                          style="
                            width: 8px;
                            height: 8px;
                            border-radius: 4px;
                            background-color: #008000;
                            margin-left: 8px;
                          "
                        ></div>
                      </div>

                      <p class="text-sm text-gray-600 capitalize">
                        {{ dropoff.get("contactPerson")?.value }}
                        <span
                          *ngIf="
                            dropoff.get('isPhlenuTrustCheckApplied')?.value
                          "
                          class="inline-flex items-center gap-1 bg-[#ddf5db] text-green-color text-[12px] font-medium px-3 py-1 rounded-full"
                          >🛡️ Verified</span
                        >
                      </p>

                      <p class="text-sm text-gray-600">
                        {{ dropoff.get("dropoffPointAddress")?.value }}
                      </p>
                      <!-- <p
                        *ngIf="orderDoc?.dropDetails?.length > 0"
                        class="text-[12px] text-blue-theme-color font-semibold mb-[5px]"
                      >
                        {{ getDropDistance(dropoff.get("id")?.value) }} km from
                        Pickup
                      </p> -->
                    </div>
                    <button mat-icon-button (click)="this.stepIndex = 1">
                      <mat-icon class="text-[#5C637E]">edit</mat-icon>
                    </button>
                  </div>

                  <!-- Item Cost Input - Shows when cash collection is enabled -->
                  <div
                    *ngIf="isCashCollection || isCashCollectionApplied"
                    class="mt-4"
                  >
                    <label class="text-sm font-medium mb-1 block"
                      >Item Cost</label
                    >
                    <div class="relative">
                      <mat-form-field appearance="outline" class="w-full">
                        <input
                          matInput
                          type="number"
                          [formControl]="dropoff.get('collectCash')"
                          (input)="onBusinessItemCostInput($event, i)"
                          placeholder="Enter amount"
                          [class.border-red-300]="
                            dropoff.get('collectCash').value &&
                            dropoff.get('collectCash').value <= 0
                          "
                        />
                        <button
                          matSuffix
                          mat-icon-button
                          (click)="updateBusinessItemCost(i)"
                          [disabled]="
                            !dropoff.get('collectCash').value ||
                            isBusinessItemCostUpdating
                          "
                          class="bg-blue-theme-color hover:bg-blue-theme-color/90 disabled:bg-gray-400 text-white-color font-medium pt-1 px-4 rounded-md transition-all duration-200 flex items-center justify-center gap-1 pb-1 text-sm"
                        >
                          <span>{{
                            isBusinessItemCostUpdating
                              ? "Updating..."
                              : isBusinessItemCostApplied[i]
                              ? "Applied"
                              : "Apply"
                          }}</span>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Security Cover Toggle - Shows when cash collection is enabled -->
                  <div *ngIf="isBusinessItemCostApplied[i]" class="mt-4">
                    <div
                      class="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                    >
                      <div class="flex items-center gap-3">
                        <img
                          src="assets/images/bulkOrder/trustCheck.svg"
                          class="w-6 h-6"
                          alt="Security Cover"
                        />
                        <div>
                          <div class="text-sm font-semibold text-[#0B1640]">
                            Security Cover
                          </div>
                          <div class="text-xs text-gray-600">
                            Protect your item with
                            <ng-container *ngIf="coverFeePercent > 0">
                              {{ coverFeePercent }}%
                            </ng-container>
                            cover for loss/damage
                          </div>
                        </div>
                      </div>
                      <mat-slide-toggle
                        [checked]="dropoff.get('isSecurityCoverApplied')?.value"
                        (change)="
                          updateBusinessSecurityCoverForDropoff(
                            i,
                            $event.checked
                          )
                        "
                        color="primary"
                      >
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <!-- Details section that can be collapsed/expanded -->
                  <div
                    [ngClass]="{
                      'max-h-0 overflow-hidden': !showDropoffDetails[i],
                      'max-h-[1000px]': showDropoffDetails[i]
                    }"
                    class="transition-all duration-300 ease-in-out"
                  >
                    <div class="grid grid-cols-2 gap-[22px]">
                      <div class="flex flex-col gap-[8px]">
                        <p class="text-[#7C8390] font-medium text-[12px]">
                          Delivery Plan
                        </p>
                        <div class="flex items-center gap-[6px]">
                          <img
                            [src]="
                              (dropoff.get('deliveryPlan')?.value ||
                                deliveryPlan) === 'express'
                                ? 'assets/images/icons/express.svg'
                                : (dropoff.get('deliveryPlan')?.value ||
                                    deliveryPlan) === 'regular'
                                ? 'assets/images/icons/regular.svg'
                                : 'assets/images/icons/saver.svg'
                            "
                            class="w-[22px] h-[22px]"
                            [alt]="
                              pickupType === 'door'
                                ? 'Door Pickup'
                                : 'Self Dropoff'
                            "
                          />

                          <p
                            class="font-medium text-blue-theme-color text-[14px]"
                          >
                            {{
                              (dropoff.get("deliveryPlan")?.value ||
                                deliveryPlan) === "express"
                                ? "Express"
                                : (dropoff.get("deliveryPlan")?.value ||
                                    deliveryPlan) === "regular"
                                ? "Regular"
                                : "Saver"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col gap-[8px]">
                        <p class="text-[#7C8390] font-medium text-[12px]">
                          What are we handling?
                        </p>
                        <p
                          class="font-medium text-blue-theme-color text-[14px]"
                        >
                          {{ getSelectedHandlingMethod(i) }}
                        </p>
                      </div>
                      <div class="flex flex-col gap-[8px]">
                        <p class="text-[#7C8390] font-medium text-[12px]">
                          Package Size
                        </p>
                        <p
                          class="font-medium text-blue-theme-color text-[14px]"
                        >
                          {{ getSelectedPackageSize(i) }}
                        </p>
                      </div>
                      <div class="flex flex-col gap-[8px]">
                        <p class="text-[#7C8390] font-medium text-[12px]">
                          Dropoff Type
                        </p>
                        <div class="flex items-center gap-[6px]">
                          <img
                            [src]="
                              dropoff.get('isDoorToDoorDropoff')?.value
                                ? 'assets/images/icons/door-pickup.svg'
                                : 'assets/images/icons/self-dropoff.svg'
                            "
                            class="w-[22px] h-[22px]"
                            [alt]="
                              dropoff.get('isDoorToDoorDropoff')?.value
                                ? 'Door Dropoff'
                                : 'Self Pickup'
                            "
                          />
                          <p
                            class="font-medium text-blue-theme-color text-[14px]"
                          >
                            {{
                              dropoff.get("isDoorToDoorDropoff")?.value
                                ? "Door Dropoff"
                                : "Self Pickup"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col gap-[8px]">
                        <p class="text-[#7C8390] font-medium text-[12px]">
                          Security Cover
                        </p>
                        <p
                          class="font-medium text-blue-theme-color text-[14px]"
                        >
                          {{
                            dropoff.get("isSecurityCoverApplied")?.value
                              ? "Enabled"
                              : "Disabled"
                          }}
                        </p>
                      </div>
                      <div class="flex flex-col gap-[8px]">
                        <p
                          class="text-[#7C8390] font-medium text-[12px] flex align-center gap-1"
                        >
                          <mat-icon>local_shipping</mat-icon>
                          Delivery Fee
                        </p>
                        <p
                          class="font-medium text-blue-theme-color text-[14px]"
                        >
                          {{
                            hasDoorToDoorDropoffAtIndex(i) &&
                            getIndividualtotalcharges(i) > 0
                              ? getIndividualtotalcharges(i)
                              : "No Fee"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <button
                    mat-button
                    color="primary"
                    class="mt-2 text-[#F54720] flex items-center"
                    (click)="toggleDropoffDetails(i)"
                  >
                    {{ showDropoffDetails[i] ? "Less" : "More" }}
                    <mat-icon class="ml-1 text-[#F54720]">{{
                      showDropoffDetails[i] ? "expand_less" : "expand_more"
                    }}</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Distribution Site Legend -->
              <div class="mt-6 max-w-[550px] w-full">
                <div class="bg-white border border-[#D8DFE7] rounded-xl p-4">
                  <div class="flex items-center gap-2 mb-2">
                    <div class="w-2 h-2 rounded-full bg-green-color"></div>
                    <span class="text-sm font-medium text-black"
                      >Near Distribution Site</span
                    >
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="w-2 h-2 rounded-full bg-orange-color"></div>
                    <span class="text-sm font-medium text-black"
                      >Far from Distribution Site</span
                    >
                  </div>
                </div>
              </div>

              <!-- Cash Collection Settings - Only show when cash collection is enabled -->
              <div
                *ngIf="isCashCollection || isCashCollectionApplied"
                class="my-6"
              >
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Subtract Delivery Fee Option -->
                  <div class="flex flex-col justify-end">
                    <label
                      class="block text-[#0B1640] text-[14px] font-medium mb-2"
                    >
                      Delivery Fee Deduction
                    </label>
                    <mat-slide-toggle
                      [checked]="subtractDeliveryFee"
                      (change)="
                        subtractDeliveryFee = $event.checked;
                        updateSubtractionSettingsOnFirebase()
                      "
                      color="primary"
                    >
                      Subtract delivery fee from item cost
                    </mat-slide-toggle>
                  </div>

                  <!-- Subtract Pickup Fee Option -->
                  <div class="flex flex-col justify-end">
                    <label
                      class="block text-[#0B1640] text-[14px] font-medium mb-2"
                    >
                      Pickup Fee Deduction
                    </label>
                    <mat-slide-toggle
                      [checked]="subtractPickupFee"
                      (change)="
                        subtractPickupFee = $event.checked;
                        updateSubtractionSettingsOnFirebase()
                      "
                      color="primary"
                    >
                      Subtract pickup fee from item cost
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-[25px]">
              <label
                class="text-[20px] font-semibold text-blue-theme-color !mb-4 block"
                >Schedule Delivery
              </label>
              <mat-slide-toggle formControlName="isScheduleDelivery">
                <span
                  class="sm:text-lg text-base text-blue-theme-color mb-2 font-semibold"
                  >Schedule This Delivery
                </span>
              </mat-slide-toggle>
              <div
                @showHide
                *ngIf="this.form.get('isScheduleDelivery')?.value"
                class="row md:w-[296px] w-full sm:w-full mb-[-10px]"
              >
                <mat-form-field appearance="fill">
                  <input
                    formControlName="scheduleDelivery"
                    [min]="this.currentTime"
                    matInput
                    readonly
                    (click)="$event.stopPropagation(); tSaleEndDate.open()"
                    [ngxMatDatetimePicker]="tSaleEndDate"
                  />
                  <button
                    mat-icon-button
                    matRipple
                    (click)="$event.stopPropagation(); tSaleEndDate.open()"
                  >
                    <img
                      matIconSuffix
                      class="w-6 aspect-square"
                      src="assets/images/icons/dateTimePicker.png"
                    />
                  </button>
                  <ngx-mat-datetime-picker
                    #tSaleEndDate
                    [showSpinners]="true"
                    [showSeconds]="false"
                    [enableMeridian]="true"
                  >
                  </ngx-mat-datetime-picker>
                </mat-form-field>
              </div>
            </div>

            <div class="" *ngIf="shouldShowPaymentMethod()">
              <h4
                class="standard-heading mt-4 !mb-3 text-base sm:text-lg md:text-xl"
              >
                Payment Method
              </h4>
              <div class="row mb-[30px]">
                <div
                  class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 md:gap-5 sm:gap-3 gap-2"
                >
                  <ng-container
                    *ngFor="let item of getPaymentMethod(); let i = index"
                  >
                    <div
                      matRipple
                      (click)="onSelectPaymentMethod(item, i)"
                      [ngClass]="
                        item.isSelected
                          ? 'border-orange-color bg-orange-color/5'
                          : 'border-[#D8DFE7] bg-transparent'
                      "
                      class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex cursor-pointer border items-center rounded-lg gap-3"
                    >
                      <img
                        draggable="false"
                        [src]="item.isSelected ? item.selectedIcon : item.icon"
                        class="w-[40px] aspect-square"
                        alt=""
                      />
                      <div class="flex-1">
                        <span
                          class="text-base text-blue-theme-color font-semibold"
                          >{{ item.title | titlecase }}</span
                        >
                        <div class="flex justify-between" *ngIf="item.id == 3">
                          <p class="text-sm font-bold text-orange-color">
                            {{ this.selectedDeliveryMethod?.currency }}
                            {{ this.selectedDeliveryMethod?.pdasWalletAmount }}
                          </p>
                        </div>
                      </div>
                      <img
                        *ngIf="item.isSelected"
                        class="absolute w-5 aspect-square top-2 right-2"
                        src="assets/images/icons/checkMark.svg"
                        alt=""
                      />
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="pb-[25px] mt-[30px]">
              <button
                mat-flat-button
                color="primary"
                class="bg-blue-theme-color gap-2 flex justify-center items-center !px-12 !h-14 text-white-color rounded-md"
                (click)="prevStep()"
              >
                Back
              </button>
            </div>

            <!-- <button mat-flat-button color="primary" class="w-40 h-12 mt-4">
              Confirm Order
            </button> -->
          </div>
        </form>
      </div>

      <!-- Mobile Payment Summary -->
      <aside class="lg:hidden block" *ngIf="shouldShowPaymentSummary">
        <div class="pt-6 summary-content">
          <div class="overflow-y-auto px-4">
            <ng-container
              *ngTemplateOutlet="paymentSummaryTemplate"
            ></ng-container>
          </div>

          <div
            class="w-full my-4 px-4"
            *ngIf="
              this.selectedDeliveryMethod &&
              this.selectedDeliveryMethod.walletAmt > 0 &&
              !this.isPharmacyOrder
            "
          >
            <mat-slide-toggle
              formControlName="isPhlenuCashApplied"
              (change)="onPhlenuCashToggle($event)"
              class="w-full flex items-center justify-between"
            >
              <span
                class="text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >
                Apply Phlenu Cash ({{ this.selectedDeliveryMethod?.currency }}
                {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
              </span>
            </mat-slide-toggle>
          </div>

          <div
            *ngIf="
              senderType === 'business' && this.selectedDeliveryMethod?.cashBack
            "
            class="bg-[#f7f7f7] mb-3 px-2 py-2 flex gap-2 border border-gray-color rounded-lg mt-4 items-start"
          >
            <img
              class="w-8 aspect-square"
              src="assets/images/ui/cashback_gif.gif"
              alt=""
            />
            <span class="text-xs text-blue-theme-color leading-4">
              Fantastic! This order will credit
              <strong
                >{{ this.selectedDeliveryMethod?.cashBack || 0 }}
                {{ this.selectedDeliveryMethod?.currency }}</strong
              >
              Phlenu cash back rewards to your account.
            </span>
          </div>

          <div class="px-4 my-8">
            <button
              (click)="confirmOrder()"
              mat-flat-button
              color="primary"
              class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12 disabled:bg-blue-theme-color/50"
              [disabled]="this.isConfirmingOrder || !this.selectedPaymentMethod"
            >
              <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
              <mat-progress-spinner
                class="custom-spinner text-white-color mx-auto"
                *ngIf="this.isConfirmingOrder"
                [diameter]="24"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
            </button>
          </div>
        </div>
      </aside>

      <aside class="summary-aside" *ngIf="shouldShowPaymentSummary">
        <div class="pt-6 summary-content">
          <div class="overflow-y-auto px-4">
            <ng-container
              *ngTemplateOutlet="paymentSummaryTemplate"
            ></ng-container>
          </div>

          <div
            class="w-full my-2 px-4"
            *ngIf="
              this.selectedDeliveryMethod &&
              this.selectedDeliveryMethod.walletAmt > 0 &&
              !this.isPharmacyOrder
            "
          >
            <mat-slide-toggle
              formControlName="isPhlenuCashApplied"
              (change)="onPhlenuCashToggle($event)"
              class="w-full"
            >
              <span class="text-black-color !text-sm font-semibold">
                Apply Phlenu Cash ({{ this.selectedDeliveryMethod?.currency }}
                {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
              </span>
            </mat-slide-toggle>
          </div>

          <div class="px-4 mb-8">
            <button
              (click)="confirmOrder()"
              mat-flat-button
              color="primary"
              class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12 disabled:bg-blue-theme-color/50"
              [disabled]="this.isConfirmingOrder || !this.selectedPaymentMethod"
            >
              <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
              <mat-progress-spinner
                class="custom-spinner text-white-color mx-auto"
                *ngIf="this.isConfirmingOrder"
                [diameter]="24"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
            </button>
          </div>
        </div>
      </aside>
    </div>
  </mat-drawer-content>
  <mat-drawer #pickupDrawer mode="over" class="w-[350px]" position="end">
    <app-pickup-locations-dialog
      *ngIf="isPickupDrawerOpen"
      [heading]="
        drawerContext.type === 'pickup'
          ? 'Recent Pickup Locations'
          : 'Recent Dropoff Locations'
      "
      [isPickup]="drawerContext.type === 'pickup' ? 1 : 0"
      [isInterRegional]="true"
      [selected]="
        drawerContext.type === 'pickup'
          ? selectedPickupLocation
          : selectedDropoffLocation
          ? [{ dropoffPoint: selectedDropoffLocation }]
          : getAllDropoffLocations()
      "
      [groupIndex]="drawerContext.dropoffIndex"
      (close)="onPickupDrawerClose()"
      (locationSelected)="onPickupLocationSelected($event)"
    ></app-pickup-locations-dialog>
  </mat-drawer>

  <!-- Payment Summary Template -->
  <ng-template #paymentSummaryTemplate>
    <ng-template #shimmerTemplate class="shimmer-card py-4">
      <!-- Payment Summary Header -->
      <div
        class="shimmer shimmer-line mt-4"
        style="width: 40%; height: 20px; margin-bottom: 15px"
      ></div>

      <!-- Delivery Charges Section -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 60%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 20%; height: 16px"
        ></div>
      </div>

      <!-- Dropoff Fee -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 50%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 15%; height: 16px"
        ></div>
      </div>

      <!-- Pickup Fee -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 45%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 12%; height: 16px"
        ></div>
      </div>

      <!-- Security Cover Charges -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 70%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 18%; height: 16px"
        ></div>
      </div>

      <!-- Divider -->
      <div style="height: 1px; background-color: #e3e3e3; margin: 6px 0"></div>

      <!-- TrustCheck Section -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 65%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 22%; height: 16px"
        ></div>
      </div>

      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 55%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 10%; height: 16px"
        ></div>
      </div>

      <!-- Divider -->
      <div style="height: 1px; background-color: #e3e3e3; margin: 6px 0"></div>

      <!-- Total Delivery Fee -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 60%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 25%; height: 16px"
        ></div>
      </div>

      <!-- Total Item Cost -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 55%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 20%; height: 16px"
        ></div>
      </div>

      <!-- Delivery Fee Deduction -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 50%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 25%; height: 16px"
        ></div>
      </div>

      <!-- Cash Collection Fee -->
      <div class="flex justify-between items-center mb-2">
        <div
          class="shimmer shimmer-line"
          style="width: 65%; height: 16px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 15%; height: 16px"
        ></div>
      </div>

      <!-- Final Divider -->
      <div style="height: 1px; background-color: #e3e3e3; margin: 6px 0"></div>

      <!-- Money to Be Paid -->
      <div class="flex justify-between items-center py-2">
        <div
          class="shimmer shimmer-line"
          style="width: 50%; height: 20px"
        ></div>
        <div
          class="shimmer shimmer-line"
          style="width: 30%; height: 20px"
        ></div>
      </div>
    </ng-template>
    <div
      *ngIf="
        !isLoadingPaymentData && getFinalAmount() > 0;
        else shimmerTemplate
      "
    >
      <ul class="">
        <li class="flex w-full py-2">
          <div class="flex flex-col w-full">
            <span
              class="bill-label text-sm sm:text-base md:text-lg text-blue-theme-color font-semibold mb-[15px]"
            >
              Payment Summary
            </span>

            <!-- Route Cards for Dropoff Locations -->
            <div
              class="flex flex-col w-full shadow-sm border border-[#D8DFE7] rounded-lg mb-4"
            >
              <ng-container
                *ngFor="let dropoff of pool?.dropDetails; let dropIndex = index"
              >
                <!-- Route Card Design -->
                <div class="route-card bg-white p-4">
                  <!-- Header with title and numbers -->
                  <div class="flex justify-between items-start">
                    <div class="flex items-center gap-2">
                      <span
                        class="text-sm sm:text-base text-black-color font-semibold capitalize"
                      >
                        {{ getDropoffName(dropIndex) }}
                        <span
                          *ngIf="pool?.dropDetails?.[dropIndex]?.isPhlenuTrustCheckApplied"
                          class="inline-flex items-center bg-[#ddf5db] text-green-color text-[10px] font-medium ml-1 px-2 rounded-full"
                          >🛡️ Verified</span
                        >
                      </span>
                    </div>
                    <div class="flex flex-col items-end gap-1">
                      <!-- Dropoff Fee Display -->
                      <div
                        *ngIf="
                          hasDoorToDoorDropoffAtIndex(dropIndex) &&
                          getIndividualtotalcharges(dropIndex) > 0
                        "
                        class="dropoff-fee-badge"
                      >
                        <mat-icon>local_shipping</mat-icon>
                        <span>
                          Delivery Fee:
                          {{ getIndividualtotalcharges(dropIndex) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Address below route -->
                  <div class="mt-1">
                    <span
                      *ngIf="getDropoffAddress(dropIndex)"
                      class="text-xs text-gray-500 line-clamp-2"
                    >
                      {{ getDropoffAddress(dropIndex) }}
                    </span>
                  </div>
                </div>

                <span
                  class="px-2"
                  *ngIf="dropIndex !== pool?.dropDetails?.length - 1"
                >
                  <mat-divider></mat-divider>
                </span>
              </ng-container>
            </div>

            <div class="flex flex-col gap-2 w-full">
              <!-- Delivery Charges -->
              <div class="flex justify-between">
                <span class="bill-label !text-[14px] text-black-color">
                  Delivery Fee
                </span>
                <span
                  class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  {{ pool?.totalBasePriceNew + pool?.totalDropoffFee || 0 }}
                </span>
              </div>

              <!-- Total charges for Individual -->
              <div
                *ngIf="senderType === 'individual' && pool?.dropTotal > 0"
                class="flex justify-between"
              >
                <span class="bill-label !text-sm text-black-color">
                  <mat-icon>local_shipping</mat-icon>
                  Delivery Fee
                </span>
                <span
                  class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  {{ pool?.newDropFee || 0 }}
                </span>
              </div>

              <!-- Pickup Fee -->
              <div *ngIf="pool?.pickupFee > 0" class="flex justify-between">
                <span class="bill-label !text-sm text-black-color">
                  Pickup Fee
                </span>
                <span
                  class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  {{ pool?.pickupFee || 0 }}
                </span>
              </div>

              <!-- Security Cover Charges -->
              <div
                *ngIf="pool?.totalCoverPrice > 0"
                class="flex justify-between"
              >
                <span class="bill-label !text-sm text-black-color">
                  Security Cover Charges
                </span>
                <span
                  class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  {{ pool?.totalCoverPrice || 0 }}
                </span>
              </div>

              <!-- TrustCheck Section -->
              <ng-container *ngIf="hasPhlenuTrustCheck()">
                <div
                  style="height: 1px; background-color: #e3e3e3; margin: 6px 0"
                ></div>
                <div class="flex justify-between">
                  <span class="bill-label !text-[14px] text-blue-theme-color">
                    Total Before TrustCheck
                  </span>
                  <span
                    class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                  >
                    {{ pool?.totalBeforeTrustCheck || 0 }}
                  </span>
                </div>
                <div class="flex justify-between">
                  <span class="bill-label !text-sm text-black-color">
                    (+) TrustCheck Fee
                  </span>
                  <span
                    class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
                  >
                    {{ pool?.totalTrustCheckFee || 0 }}
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
        </li>

        <!-- Total Delivery Fee Section -->
        <ng-container *ngIf="pool?.paymentDirection != 2">
          <div
            style="height: 1px; background-color: #e3e3e3; margin: 6px 0"
          ></div>
          <div class="flex justify-between">
            <span class="bill-label !text-[14px] text-blue-theme-color">
              Total Delivery Fee
            </span>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
            >
              {{ pool?.totalAfterTrustCheck || 0 }}
            </span>
          </div>
        </ng-container>

        <!-- Total Item Cost Section -->
        <ng-container
          *ngIf="
            cashCollection &&
            ((senderType === 'individual' && itemCost) ||
              (senderType === 'business' && pool?.totalCashCollected > 0)) &&
            pool?.paymentDirection != 2
          "
        >
          <div
            style="height: 1px; background-color: #e3e3e3; margin: 6px 0"
          ></div>
          <div class="flex justify-between">
            <span class="bill-label !text-[14px] text-blue-theme-color">
              Total Item Cost
            </span>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
            >
              {{ pool?.totalCashCollected || 0 }}
            </span>
          </div>
        </ng-container>

        <!-- Delivery Fee Deduction -->
        <ng-container
          *ngIf="
            pool?.isSubtractPriceFromDeliveryFee == 1 ||
            pool?.isSubtractPriceFromPickUpFee == 1
          "
        >
          <div class="flex justify-between">
            <div class="flex items-center gap-[4px]">
              <span class="bill-label !text-sm text-black-color">
                (-) Delivery Fee
              </span>
              <mat-icon
                matTooltipClass="custom-tooltip"
                matTooltip="Your delivery fee includes the cost to deliver, drop-off handling, and extra services like item verification and cash collection (if applicable)"
                matTooltipPosition="above"
                class="text-dark-gray cursor-pointer text-[12px]"
                >info_outline</mat-icon
              >
            </div>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
            >
              {{ getDeliveryFee() }}
            </span>
          </div>
        </ng-container>

        <!-- Final Divider -->
        <div
          style="height: 1px; background-color: #e3e3e3; margin: 6px 0"
        ></div>
      </ul>
      <ng-container *ngIf="pool?.isCashCollectionApplied == 1">
        <div class="flex justify-between mt-[3px]">
          <span class="bill-label !text-sm text-black-color">
            Cash Collection Fee
          </span>

          <span
            class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >
            {{ pool?.totalCashCollectionFee }}
          </span>
        </div>
      </ng-container>
      <div class="flex justify-between py-2">
        <span
          class="bill-label !text-sm sm:!text-lg text-orange-color font-semibold"
        >
          {{
            pool?.paymentDirection == 0
              ? "Money to Be Paid"
              : pool?.paymentDirection == 1
              ? "Money to Be Returned"
              : "Total Delivery Fee"
          }}
        </span>
        <span
          class="bill-value !text-sm sm:!text-lg text-orange-color font-medium"
        >
          {{ pool?.country == "Nigeria" ? "NGN" : "GHS" }}
          {{
            pool?.paymentDirection == 2
              ? pool?.totalCharges || 0
              : pool?.settlementAmount || 0
          }}
        </span>
      </div>

      <div
        *ngIf="
          senderType === 'business' &&
          this.selectedDeliveryMethod?.grossTotal > 0
        "
        class="flex justify-between py-2"
      >
        <span class="bill-label text-sm text-black-color"
          >Discounted Amount</span
        >
        <span class="bill-value text-blue-theme-color font-bold">
          {{ this.selectedDeliveryMethod?.grossTotal || 0 }}
        </span>
      </div>

      <div
        *ngIf="
          senderType === 'business' && this.selectedDeliveryMethod?.cashBack
        "
        class="bg-[#f7f7f7] mb-3 px-2 py-2 flex gap-2 border border-gray-color rounded-lg mt-4 items-start"
      >
        <img
          class="w-8 aspect-square"
          src="assets/images/ui/cashback_gif.gif"
          alt=""
        />
        <span class="text-xs text-blue-theme-color leading-4">
          Fantastic! This order will credit
          <strong
            >{{ this.selectedDeliveryMethod?.cashBack || 0 }}
            {{ this.selectedDeliveryMethod?.currency }}</strong
          >
          Phlenu cash back rewards to your account.
        </span>
      </div>
    </div>
  </ng-template>
</mat-drawer-container>
